import {
  ARUS_KAS,
  ARUS_KAS_FORM,
  DETAIL_CASHFLOW,
  HISTORY_ARUS_KAS,
  URL_406,
  URL_ADDRESS_BOOK,
  URL_AGENT_APPROVAL,
  URL_ANNUAL_CAPACITY,
  URL_AP2HI_INSIGHT,
  URL_AP2HI_LOG,
  URL_APPROVAL_BUY,
  URL_APPROVAL_SELL,
  URL_APPROVAL_WITHDRAWAL,
  URL_ATTENDANCE,
  URL_ATTENDANCE_INDIVIDUAL,
  URL_ATTENDANCE_REPORT,
  URL_ATTENDANCE_REPORT_MEMBER,
  URL_ATTENDANCE_TODAY,
  URL_BALANCE,
  URL_CATCHES,
  URL_CATCHES_DETAIL,
  URL_CENTER_ATTENDANCE,
  URL_CHECK_FARMERS,
  URL_COMPANIES,
  URL_COMPANIES_ADD,
  URL_CONFIGURATIONS,
  URL_CONFIRM_PIN_TALANGIN,
  URL_CONFIRM_PIN_TRANSAKSI,
  URL_DASHBOARD_TRACEABILITY,
  URL_DASHBOARD_TRACEABILITY_DETAIL,
  URL_DETAIL_INVENTORI_INTELLIGENCE,
  URL_DETAIL_INVENTORY,
  URL_DETAIL_PIUTANG,
  URL_DETAIL_PROCESS,
  URL_DETAIL_PRODUCTION_UNIT,
  URL_DETAIL_TAGIHAN_TALANGIN,
  URL_DETAIL_TRANSACTION,
  URL_DETAIL_TRANSACTION_ID,
  URL_DETAIL_UTANG,
  URL_DETAIL_WAREHOUSE,
  URL_EMPLOYEE_PAYMENTS,
  URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION,
  URL_EMPLOYEE_PAYMENTS_SUMMARY,
  URL_EVENT,
  URL_EVENT_APPROVAL,
  URL_EVENT_CERTIFICATE,
  URL_EVENT_CERTIFICATE_DETAIL,
  URL_EVENT_FORM,
  URL_EVENT_PARTICIPANT,
  URL_EVENT_PARTICIPANT_FORM,
  URL_EVENT_PARTNER,
  URL_EVENT_PARTNER_FORM,
  URL_EVENT_TIMELINE,
  URL_FARMERS,
  URL_FARMERS_DETAIL,
  URL_FARMERS_GROUPS,
  URL_FARMERS_PENDING,
  URL_FARMERS_REGIST,
  URL_FARMERS_SHARED,
  URL_FARMERS_SUBGROUP,
  URL_FINDORA_DASHBOARD,
  URL_FINDORA_LOGS,
  URL_FINDORA_PRODUCT_MAPPING,
  URL_FINDORA_PRODUCT_MAPPING_SCHEMA,
  URL_FINDORA_SYNC_DATA,
  URL_FINISH_KURSUS,
  URL_FISHERIES,
  URL_FISHERIES_ADD,
  URL_FORGET_PASSWORD_STEP_1,
  URL_FORGET_PASSWORD_STEP_2,
  URL_FORM_PROCESS,
  URL_FORM_PRODUCTION_UNIT,
  URL_FORM_TRANSFER_INVENTORY,
  URL_FORM_UTANG_PIUTANG,
  URL_FORM_WAREHOUSE,
  URL_FULFILMENT_REPORT,
  URL_FULFILMENT_REPORT_ID,
  URL_GEARS,
  URL_GRIEVANCE,
  URL_HARVEST,
  URL_HOMEPAGE,
  URL_INVENTORI_INTELLIGENCE,
  URL_INVENTORY,
  URL_INVENTORY_MEMBERS,
  URL_KURSUS,
  URL_KURSUS_DETAIL,
  URL_LEARNIING_REPORT,
  URL_LIST_TRANSACTIONS,
  URL_LOGIN_PASSWORD,
  URL_MUTATION_REPORT,
  URL_MUTATION_REPORT_ID,
  URL_NOTIF_INBOX,
  URL_PAYMENT_HISTORY,
  URL_PIUTANG,
  URL_PORTS,
  URL_PREVIEW_DOCUMENT,
  URL_PROCESS,
  URL_PROCESSING_REPORT,
  URL_PRODUCTION_UNIT,
  URL_PROJECT_SUMMARY_DASHBOARD,
  URL_PROJECTS_ADD,
  URL_PROJECTS_EDIT,
  URL_PROJECTS_MENU,
  URL_QR_PRINTING,
  URL_REPORT_PNBP,
  URL_REPORT_PNBP_DETAIL,
  URL_SESSION_PROCESS,
  URL_TNC_PRIVATE,
  URL_TRANSACTION_SUMMARY,
  URL_TRANSFER_INVENTORY,
  URL_TRANSFER_INVENTORY_DETAIL,
  URL_UTANG,
  URL_UTANG_APPROVAL,
  URL_VESSELS,
  URL_VESSELS_ADD,
  URL_VESSELS_DETAIL,
  URL_WAREHOUSE,
  URL_WHISTLE_BLOWINGS,
  URL_WORKPLACE,
} from 'utils/pathUrl'

export const translations = {
  '/request-transaction': 'Permintaan Transaksi',
  '/transaction': 'Konfirmasi Transaksi',
  '/success-transaction': 'Konfirmasi diterima',
  '/syarat-dan-ketentuan': 'Syarat dan Ketentuan',
  '/sukses-verifikasi': 'Sukses Verifikasi',
  '/public/order': 'Permintaan Transaksi',
  '/plot/view/:code': 'Landplot',
  '/plot/view/pin/:lat/:long': 'Landplot',
  '/spatial': 'Landplot',
  [URL_KURSUS_DETAIL]: 'Detail Kursus',
  [URL_FINISH_KURSUS]: 'Finish Kursus',
  [URL_FORGET_PASSWORD_STEP_1]: 'Atur Ulang Password',
  [URL_FORGET_PASSWORD_STEP_2]: 'Atur Ulang Password',
  [URL_FORGET_PASSWORD_STEP_2]: 'Atur Ulang Password Berhasil',
  [URL_FORGET_PASSWORD_STEP_2]: 'Sambungkan Akun',
  '/public-payment': 'Pembayaran',
  '/public-payment-instruksi': 'Pembayaran instruksi',
  '/public-payment-expired': 'Pembayaran Expired',
  '/public-payment-success': 'Pembayaran Sukses',
  '/public-payment-failed': 'Pembayaran Gagal',
  '/login-v2': 'Login',
  '/pin': 'Login Pin',
  '/otp': 'Login OTP',
  '/traceability': 'Traceability',
  [URL_406]: 'Tidak Ada Akses',
  '/login': 'Login',
  '/': 'Beranda',
  '/transaksi-pembelian-tambah-komoditas': 'Pembelian',
  '/transaksi-pembelian-pembayaran': 'Pembelian Pembayaran',
  '/transaksi-pembelian-pembayaran-uang-belanja-konfirmasi':
    'Pembelian Konfirmasi Pembayaran',
  '/transaksi-pembelian-pembayaran-talangin': 'Pembelian Talangin',
  [URL_DETAIL_TRANSACTION]: 'Detail Transaksi',
  '/transaksi-pembelian-cash': 'Pembelian Tunai',
  '/transaksi-pembelian-sukses': 'Pembelian Berhasil',
  '/purchase-commodity': 'Pembelian',
  '/sell-commodity': 'Penjualan',
  '/sell-commodity-success': 'Penjualan Berhasil',
  '/topup': 'Tambah Uang Belanja',
  '/tagihan-talangin': 'Tagihan Talangin',
  '/penarikan-uang': 'Uang Usaha',
  '/perpanjang-tempo-pembayaran': 'Perpanjang Tempo Pembayaran',
  '/perpanjang-tempo-pembayaran-konfirmasi':
    'Perpanjang Tempo Pembayaran Konfirmasi',
  [URL_APPROVAL_BUY]: 'Permintaan Persetujuan Pembelian',
  [URL_APPROVAL_SELL]: 'Permintaan Persetujuan Penjualan',
  [URL_APPROVAL_WITHDRAWAL]: 'Permintaan Persetujuan Penarikan Uang',
  [URL_AGENT_APPROVAL]: 'Permintaan Menjadi Agen',
  [URL_FARMERS]: 'Daftar Anggota',
  [URL_FARMERS_REGIST]: 'Tambah Anggota Data',
  [URL_FARMERS_DETAIL]: 'Detail Anggota',
  [URL_CHECK_FARMERS]: 'Tambah Anggota',
  [URL_FARMERS_PENDING]: 'Daftar Anggota Pending',
  [URL_FARMERS_GROUPS]: 'Daftar Grup',
  [URL_FARMERS_SHARED]: 'Daftar Anggota Bersama',
  [URL_FARMERS_SUBGROUP]: 'Detail Grup',
  '/pengaturan-profile': 'Profil Saya',
  '/pengaturan-perusahaan': 'Perusahaan',
  '/pengaturan-tim': 'Tim',
  '/pengaturan-password': 'Password',
  '/repo-komoditas': 'Dokumen Repo',
  '/repo-komoditas/list': 'Daftar Pengajuan Repo',
  [URL_INVENTORY]: 'Inventori',
  [URL_INVENTORY_MEMBERS]: 'Inventori Anggota',
  [URL_DETAIL_INVENTORY]: 'Detail Inventori',
  [ARUS_KAS]: 'Laporan Arus Kas',
  [HISTORY_ARUS_KAS]: 'Riwayat Arus Kas',
  [ARUS_KAS_FORM]: 'Catat Arus Kas',
  [URL_UTANG]: 'Utang',
  [URL_UTANG_APPROVAL]: 'Konfirmasi Catatan Utang',
  [URL_FORM_UTANG_PIUTANG]: 'Catat Utang Piutang',
  [URL_PIUTANG]: 'Piutang',
  [URL_TNC_PRIVATE]: 'Syarat dan Ketentuan',
  [URL_VESSELS]: 'Daftar Kapal',
  [URL_VESSELS_ADD]: 'Tambah Kapal',
  [URL_VESSELS_DETAIL]: 'Detail Vessel',
  [URL_CATCHES]: 'Daftar Perjalanan',
  [URL_CATCHES_DETAIL]: 'Detail Perjalanan',
  [URL_WHISTLE_BLOWINGS]: 'Daftar Laporan Pengaduan',
  [URL_GEARS]: 'Daftar Gears',
  [URL_PORTS]: 'Daftar Ports',
  [URL_COMPANIES]: 'Daftar Perusahaan',
  [URL_COMPANIES_ADD]: 'Tambah Perusahaan',
  [URL_FISHERIES]: 'Daftar Fisheries',
  [URL_FISHERIES_ADD]: 'Tambah Fishery',
  [URL_AP2HI_LOG]: 'Log History',
  [URL_AP2HI_INSIGHT]: 'Laporan Tangkapan',
  [URL_KURSUS]: 'Kursus',
  [URL_WAREHOUSE]: 'Gudang',
  [URL_FORM_WAREHOUSE]: 'Tambah Gudang',
  [URL_TRANSFER_INVENTORY]: 'Daftar Transfer Inventori',
  [URL_FORM_TRANSFER_INVENTORY]: 'Transfer Inventori',
  [URL_DETAIL_WAREHOUSE]: 'Detail Gudang',
  [URL_BALANCE]: 'Uang Belanja',
  [URL_LEARNIING_REPORT]: 'Laporan Pembelajaran',
  [URL_LOGIN_PASSWORD]: 'Login Password',
  [URL_CONFIRM_PIN_TALANGIN]: 'Konfirmasi PIN Talangin',
  [URL_CONFIRM_PIN_TRANSAKSI]: 'Konfirmasi PIN Transaksi',
  [URL_DETAIL_TRANSACTION_ID]: 'Detail Transaksi',
  [URL_ADDRESS_BOOK]: 'Daftar Kontak',
  [`/${URL_APPROVAL_BUY}`]: 'Permintaan Persetujuan Pembelian',
  [`/${URL_APPROVAL_BUY}/${URL_APPROVAL_SELL}`]:
    'Permintaan Persetujuan Penjualan',
  [`/${URL_APPROVAL_BUY}/${URL_APPROVAL_WITHDRAWAL}`]:
    'Permintaan Persetujuan Penarikan Uang',
  '/order-adjustment': 'Penyesuaian Pesanan',
  '/confirmation-end': 'Konfirmasi Transaksi',
  [URL_CONFIGURATIONS]: 'Konfigurasi',
  [URL_REPORT_PNBP]: 'Laporan PNBP',
  [URL_REPORT_PNBP_DETAIL]: 'Detail Laporan PNBP',
  [URL_HARVEST]: 'Catat Hasil Panen',
  '/register': 'Buat Password',
  [URL_WORKPLACE]: 'Alat Bantu',
  [URL_ATTENDANCE_REPORT]: 'Ringkasan Absensi',
  [URL_ATTENDANCE_TODAY]: 'Laporan Hari Ini',
  [URL_ATTENDANCE_INDIVIDUAL]: 'Absensi Karyawan',
  [URL_NOTIF_INBOX]: 'Notifikasi',
  [URL_MUTATION_REPORT]: 'Laporan Ketelusuran',
  [URL_MUTATION_REPORT_ID]: 'Detail Laporan Ketelusuran',
  [URL_FULFILMENT_REPORT]: 'Pemenuhan Order',
  [URL_FULFILMENT_REPORT_ID]: 'Detail Pemenuhan Order',
  [URL_ATTENDANCE_REPORT_MEMBER]: 'Laporan Absensi Anggota',
  [URL_ATTENDANCE]: 'Absensi',
  [URL_LIST_TRANSACTIONS]: 'Daftar Transaksi',
  [URL_DETAIL_UTANG]: 'Detail Utang',
  [URL_DETAIL_PIUTANG]: 'Detail Piutang',
  [DETAIL_CASHFLOW]: 'Detail Arus Kas',
  [URL_DETAIL_TAGIHAN_TALANGIN]: 'Detail Tagihan Talangin',
  [URL_FINDORA_SYNC_DATA]: 'Sinkronisasi Data',
  [URL_FINDORA_PRODUCT_MAPPING]: 'Pemetaan Produk',
  [URL_FINDORA_PRODUCT_MAPPING_SCHEMA]: 'Pemetaan Bahan Baku',
  [URL_TRANSFER_INVENTORY_DETAIL]: 'Detail Transfer Inventory',
  [URL_PROCESSING_REPORT]: 'Laporan Proses',
  [URL_PRODUCTION_UNIT]: 'Unit Produksi',
  [URL_DETAIL_PRODUCTION_UNIT]: 'Detail Unit Produksi',
  [URL_FORM_PRODUCTION_UNIT]: 'Form Unit Produksi',
  [URL_FINDORA_LOGS]: 'Log Sinkronisasi',
  [URL_FINDORA_DASHBOARD]: 'ESG',
  [URL_GRIEVANCE]: 'Daftar Laporan Pengaduan',
  [URL_EVENT_PARTNER]: 'Event Partner',
  [URL_EVENT_PARTNER_FORM]: 'Event Partner Form',
  [URL_EVENT]: 'Event',
  [URL_EVENT_FORM]: 'Event Form',
  [URL_EVENT_PARTICIPANT]: 'Peserta Event',
  [URL_EVENT_PARTICIPANT_FORM]: 'Peserta Event Form',
  [URL_PROJECTS_MENU]: 'Daftar Projects',
  [URL_SESSION_PROCESS]: 'Sesi Proses',
  [URL_PROCESS]: 'Pilih Proses',
  [URL_FORM_PROCESS]: 'Form Proses',
  [URL_EVENT_APPROVAL]: 'Event Approval',
  [URL_EVENT_TIMELINE]: 'Timeline Event',
  [URL_EVENT_CERTIFICATE]: 'Sertifikat Event Digital',
  [URL_EVENT_CERTIFICATE_DETAIL]: 'Detail Sertifikat Event Digital',
  [URL_PROJECT_SUMMARY_DASHBOARD]: 'Ringkasan Project',
  [URL_EMPLOYEE_PAYMENTS]: 'List of Disbursements',
  [URL_EMPLOYEE_PAYMENTS_SUMMARY]: 'Salary Payment Summary',
  [URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION]: 'Auto Calculation',
  [URL_PREVIEW_DOCUMENT]: 'Preview Document',
  [URL_PROJECTS_ADD]: 'Tambah Project',
  [URL_PROJECTS_EDIT]: 'Edit Project',
  [URL_PAYMENT_HISTORY]: 'Riwayat Pembayaran',
  '/master-items': 'Manajemen Barang',
  [URL_DETAIL_PROCESS]: 'Detail Proses',
  [URL_ANNUAL_CAPACITY]: 'Employee Overview',
  [URL_INVENTORI_INTELLIGENCE]: 'Inventory Intelligence',
  [URL_DETAIL_INVENTORI_INTELLIGENCE]: 'Detail Inventory Intelligence',
  [URL_HOMEPAGE]: 'Beranda',
  [URL_CENTER_ATTENDANCE]: 'Absensi Pusat',
  [URL_DASHBOARD_TRACEABILITY]: 'Dashboard Ketelusuran',
  [URL_DASHBOARD_TRACEABILITY_DETAIL]: 'Detail Dashboard Ketelusuran',
  [URL_QR_PRINTING]: 'Print QR',
  [URL_TRANSACTION_SUMMARY]: "Ringkasan Transaksi",
}
